import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=27d983b7&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=27d983b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d983b7",
  null
  
)

export default component.exports